import { render } from "./Industry-table-ranking.vue?vue&type=template&id=bab0bd78"
import script from "./Industry-table-ranking.vue?vue&type=script&lang=ts"
export * from "./Industry-table-ranking.vue?vue&type=script&lang=ts"
script.render = render

export default script